import { QrCodeScanner as ScannerIcon } from '@mui/icons-material';
import TransitionSelector from './ScannerPanel/TransitionSelector';
import { Option } from '@/components/inputs/AutocompleteInput';
import { TransitionIncludedStatus } from '../../models';
import CodeInput from './ScannerPanel/CodeInput';
import SectionHeader from '../SectionHeader';
import { ToggleSwitch } from '@/components';
import { Alert } from '@mui/material';
import React from 'react';

interface ScannerPanelProps {
  transition: Option | null;
  setTransition: (option: Option | null) => void;
  transitionOptions: Option[];
  isTransitionsLoading: boolean;
  inputValue: string;
  setInputValue: (val: string) => void;
  isScannerActive: boolean;
  setIsScannerActive: (active: boolean) => void;
  isSearchingShipping: boolean;
  isScanReady: boolean;
  isTransitionLocked: boolean;
  includedStatuses: TransitionIncludedStatus[];
  isLoadingStatuses: boolean;
  inputRef: React.RefObject<HTMLInputElement>;
  onScan: (event: React.KeyboardEvent) => void;
}

const ScannerPanel = ({
  transition,
  setTransition,
  transitionOptions,
  isTransitionsLoading,
  inputValue,
  setInputValue,
  isScannerActive,
  setIsScannerActive,
  isSearchingShipping,
  isScanReady,
  isTransitionLocked,
  includedStatuses,
  isLoadingStatuses,
  inputRef,
  onScan,
}: ScannerPanelProps) => {
  return (
    <div className='bg-white rounded-xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100 p-8'>
      <div className='flex items-center justify-between mb-2'>
        <SectionHeader
          title='Panel de Escaneo'
          icon={ScannerIcon}
          colorClass='bg-[#ff7500]'
        />

        <div className='flex items-center gap-4'>
          <span
            className={`text-[11px] font-black uppercase tracking-widest ${
              isScannerActive ? 'text-orange-600' : 'text-gray-400'
            }`}
          >
            {isScannerActive ? 'Lector Conectado' : 'Lector Pausado'}
          </span>
          <ToggleSwitch
            checked={isScannerActive}
            onChange={setIsScannerActive}
            ariaLabel='Activar/Desactivar Lector'
          />
        </div>
      </div>

      <div className='flex flex-col gap-6 mt-4'>
        <div className='grid grid-cols-1 gap-6 items-end md:grid-cols-2'>
          <TransitionSelector
            transition={transition}
            setTransition={setTransition}
            transitionOptions={transitionOptions}
            isTransitionsLoading={isTransitionsLoading}
            disabled={isTransitionLocked}
          />

          <CodeInput
            inputValue={inputValue}
            setInputValue={setInputValue}
            onScan={onScan}
            isScannerActive={isScannerActive}
            isSearchingShipping={isSearchingShipping}
            inputRef={inputRef}
            disabled={!isScanReady}
          />
        </div>

        {transition && !isLoadingStatuses && includedStatuses.length > 0 && (
          <Alert severity='warning'>
            Los pedidos a escanear deben estar en alguno de los siguientes estados:{' '}
            <strong>
              {includedStatuses.map((s) => s.includedStatusCommercialName).join(', ')}
            </strong>
          </Alert>
        )}
      </div>
    </div>
  );
};

export default ScannerPanel;
